import 'select2/dist/js/select2.full.js'

jQuery('.gform_wrapper .ginput_container_select select').select2({
    width: '100%'
})

jQuery( '.resources__filters .topic').select2({
    width: '100%',
    templateSelection: function(data){
        let selectedOptions = jQuery( '.resources__filters .topic' ).select2('data')

        let output = '(' + selectedOptions.length + ') '

        selectedOptions.forEach( function( item ) {
            output += item.text

            if( selectedOptions.length > 1 )
                output += ', '
        })

        if( selectedOptions.length > 1 || output.length > 20 )
            output = output.substring(0, 20) + '...'

        return '<span tabindex="0">'+output+'</span>'

    },
    allowClear: true,
    escapeMarkup: function(m) {
        return m
    }
})

jQuery( '.resources__filters .type').select2({
    width: '100%',
    templateSelection: function(data){
        let selectedOptions = jQuery( '.resources__filters .type' ).select2('data')

        let output = '(' + selectedOptions.length + ') '

        selectedOptions.forEach( function( item ) {
            output += item.text

            if( selectedOptions.length > 1 )
                output += ', '
        })

        if( selectedOptions.length > 1 || output.length > 20 )
            output = output.substring(0, 20) + '...'

        return '<span tabindex="0">'+output+'</span>'

    },
    allowClear: true,
    escapeMarkup: function(m) {
        return m
    }
})

jQuery( '.resources__filters .language').select2({
    width: '100%',
    templateSelection: function(data){
        let selectedOptions = jQuery( '.resources__filters .language' ).select2('data')

        let output = '(' + selectedOptions.length + ') '

        selectedOptions.forEach( function( item ) {
            output += item.text

            if( selectedOptions.length > 1 )
                output += ', '
        })

        if( selectedOptions.length > 1 || output.length > 20 )
            output = output.substring(0, 20) + '...'

        return '<span tabindex="0">'+output+'</span>'

    },
    allowClear: true,
    escapeMarkup: function(m) {
        return m
    }
})

jQuery('.imageset_categories').select2({
    width: '100%'
})